import { Column, defaultColActionDef, defaultColDef, TABLE_ACTION } from '@qrios/frontend-library';

import { predefinedColumns } from '../../../../../common/table/columns/predefinedColumns';

const ACTIONS = [TABLE_ACTION.INFO];
export const columns: Column[] = [
  {
    ...defaultColDef,
    field: 'id',
    headerName: 'Operation Id',
    flex: 2
  },
  predefinedColumns.date({}),
  predefinedColumns.status({}),
  {
    ...defaultColDef,
    field: 'recipientMsisdn',
    headerName: 'Recipient',
    flex: 2
  },
  {
    ...defaultColDef,
    field: 'operator',
    headerName: 'Operator',
    flex: 1
  },
  predefinedColumns.cost({}),
  {
    ...defaultColActionDef(ACTIONS)
  }
];
